export default __webpack_public_path__ + "static/media/loss-setup-step1.e7317bf4.gif";